import axios from "axios";

// You can use your own logic to set your local or production domain
// const baseDomain = "https://jsonplaceholder.typicode.com";
// const baseDomain = "https://icici-careers.in/BrainstormApi/";
// const baseDomain = "http://localhost:7666/";
const baseDomain = process.env.VUE_APP_BASE_URL_CORE_API;
// const baseDomain = "https://cera-api.aiab.in/api/";
//const baseDomain = "http://35.207.243.82/";
// The base URL is empty this time due we are using the jsonplaceholder API
const baseURL = `${baseDomain}`;

const API = axios.create({
  baseURL: baseURL,
  headers: {
    "community-name": process.env.VUE_APP_COMMUNITY_NAME,
  },
});

export default API;

// export default axios.create({
//   baseURL
// });
